import { useUpdateApplicationsSetting } from 'src/hooks/applications-setting/update-applications-setting.hook';
import { useCreateApplicationsSetting } from 'src/hooks/applications-setting/create-applications-setting.hook';

import { ApplicationsForm } from '../applications-form';
import { EditWrapper } from './applications-edit.styles';
import { IApplicationSetting } from '../../applications.interfaces';

const ApplicationsEdit = ({
  application,
  onClose,
  companyId,
}: {
  application: IApplicationSetting;
  onClose: () => void;
  companyId?: string;
}) => {
  const { updateApplicationsSetting } = useUpdateApplicationsSetting({ onSuccess: onClose });
  const { createApplicationsSetting } = useCreateApplicationsSetting({ onSuccess: onClose });

  const handler = application?._id ? updateApplicationsSetting : createApplicationsSetting;

  const onFinish = (values: IApplicationSetting) => {
    handler({
      variables: {
        payload: {
          ...values,
          companyId,
          type: application?.type,
          ...(application?._id && { _id: application._id }),
        },
      },
    });
  };

  return (
    <EditWrapper>
      <ApplicationsForm
        onClose={onClose}
        initialValues={application}
        onFinish={onFinish}
        isEdit={!!application?._id}
      />
    </EditWrapper>
  );
};

export default ApplicationsEdit;
